module.exports = __webpack_public_path__ + "static/media/hacker.cd75621b.png";